/** @format */

import config from 'config';

import angular from 'angular';

import { AuctionModelsModule } from 'crowdcomms-js/lib/galabid/auction/models';
import { AuthModule } from 'crowdcomms-js/lib/galabid/auth';
import { InfoboothModelsModule } from 'crowdcomms-js/lib/galabid/infobooth/models';
import { ItemModelsModule } from 'crowdcomms-js/lib/galabid/item/models';
import { RealtimeModule } from 'crowdcomms-js/lib/galabid/realtime';

import { ControllersModule } from './controllers';
import { DirectivesModule } from './directives';
import { I18nModule } from './i18n';
import { RoutesModule } from './routes';
import { SharedComponentsModule } from './components';
import { ServicesModule } from './services';
import { UiModule } from './ui';

import { AppConfig } from './app.config.js';
import { AppRoutesConfig } from './app.routes.js';
import { AppRun } from './app.run.js';

export const SharedModule = angular
    .module('galabid-presenter.shared', [
        AuctionModelsModule,
        AuthModule,
        InfoboothModelsModule,
        ItemModelsModule,
        RealtimeModule,
        ControllersModule,
        DirectivesModule,
        I18nModule,
        RoutesModule,
        SharedComponentsModule,
        ServicesModule,
        UiModule,
    ])
    .constant('CONFIG', config)
    .config(AppConfig)
    .config(AppRoutesConfig)
    .run(AppRun).name;
